<template>
    <div class="d-flex align-items-center justify-content-center">
        <template v-if="row.Positive == true">
            <span class="material-icons-round text-success">add</span>
        </template>
        <template v-else-if="row.Positive == false">
            <span class="material-icons-round text-danger">remove</span>
        </template>
        <template v-else>
            <span class="material-icons-outlined text-info">circle</span>
        </template>
    </div>
</template>

<script>
export default {
    props:{
        row:Object,
        field:Object
    },
}
</script>

<style>

</style>